import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { slice } from './routesTable.slice';

export const useAddTempRoute = () => {
  const dispatch = useDispatch();
  return useCallback(() => dispatch(slice.actions.addPage()), [dispatch]);
};
